"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderButton = void 0;
var React = __importStar(require("react"));
var useHeaderProps_1 = require("../hooks/useHeaderProps");
var react_1 = require("@chakra-ui/react");
var getUnderlinedStyle_1 = require("./_shared/getUnderlinedStyle");
var getRoundedStyle_1 = require("./_shared/getRoundedStyle");
exports.HeaderButton = React.forwardRef(function (_a, ref) {
    var children = _a.children, active = _a.active, underlined = _a.underlined, isRounded = _a.isRounded, buttonProps = __rest(_a, ["children", "active", "underlined", "isRounded"]);
    var colorSet = (0, useHeaderProps_1.useHeaderProps)().colorSet;
    var highlightStyle = {
        bg: colorSet === null || colorSet === void 0 ? void 0 : colorSet.backgroundHighlight,
    };
    return (React.createElement(react_1.Button, __assign({ p: 2, h: 9, color: colorSet === null || colorSet === void 0 ? void 0 : colorSet.text, ref: ref }, (active && highlightStyle), { fontWeight: 500, _hover: highlightStyle, _focus: highlightStyle, _active: highlightStyle, variant: "ghost", borderRadius: 3, lineHeight: 6 }, (underlined && (0, getUnderlinedStyle_1.getUnderlinedStyle)(colorSet === null || colorSet === void 0 ? void 0 : colorSet.accent1)), (isRounded && (0, getRoundedStyle_1.getRoundedStyle)()), buttonProps), children));
});
